import { Container, SimpleGrid } from '@hover/blueprint';
import React from 'react';
import ContentCard from './ContentCard';

interface Props {
  heading: string;
  body: string;
  image: React.ReactNode;
  isReversed?: boolean;
}

const Point: React.FC<Props> = ({ heading, body, image, isReversed }) => (
  <Container maxW="1200px" px={500} mb={{ base: '72px', desktop: '72px' }}>
    <SimpleGrid
      columns={{ base: 1, desktop: 2 }}
      alignItems="center"
      spacing={{ base: 700, desktop: 1100 }}
      dir={isReversed ? 'rtl' : 'ltr'}
    >
      <ContentCard
        maxW="xl"
        header={heading}
        topBody={body}
        textAlign="left"
        bodyWidth="440px"
        display="flex"
        gap="1rem"
        alignItems={isReversed ? 'flex-end' : 'flex-start'}
      />
      <Container px={0} centerContent>
        {image}
      </Container>
    </SimpleGrid>
  </Container>
);

export default Point;
